<template>
    <div id="contendor-principal-salidasDelNotificador">
        <div id="contenedor-encabezados-salidasDelDia" class="text-left">
            <h1>Salidas del notificador</h1>
            <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
                <div class="flex-grow-1"><button type="button" @click="evtRegresarVistaPrincipal" class="btn btn-primary"><i class="fas fa-long-arrow-alt-left" style="font-size:20px;"></i></button></div>
                <div class="flex-grow-1" style="padding-left: 11em;"><h5>Consulta y constitución cédulas de salida</h5></div>
                <div class="flex-grow-1"></div>
            </div>
            <div id="contenedor-salidas" class="area">
               <!-- <div id="encabezados-instrucciones">
                   <div class="d-flex justify-content-between align-items-center">
                       <h4>Seleccione la fecha para obtener la informacion acerca de la salida del notificador.</h4>
                       <button type="button" @click="evtRegresarVistaPrincipal" class="btn btn-primary mr-4"><i class="fas fa-long-arrow-alt-left"></i></button>
                   </div>
                   <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
               </div> -->
               <div id="contenedor-historial-salidas">
                    <div style=" padding: 8px;">
                        <div class="d-flex">
                            <!-- <h5>Salida de hoy [ {{diaActual.format('DD/MM/YYYY')}} ]</h5> -->
                            <h3>Constituir cédulas</h3>
                        </div>
                    </div>
                   <div id="contenedor-salida-diaActual" class="">
                       <!-- <div id="encabezado-salida-diaActual" class="d-flex justify-content-between align-items-center">
                           <h5>Salida de hoy [ {{diaActual.format('YYYY-MM-DD')}} ]</h5>
                       </div> -->
                    <div class="form-inline mt-2 mb-4">
                        <h6 for="fecha-busqueda-cs-sn" class="mr-2">Fecha de búsqueda salida</h6>
                        <input id="fecha-busqueda-cs-sn" type="date" v-model="constituciones.fechaBusqueda" class="form-control mr-3" />
                        <button type="button" @click="evtBuscarSalidaFechaEspecificaParaConstitucion" class="btn btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                    </div>
                   <!--  <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/> -->
                    <CTablaGenericaCedulas class="mt-3 table-responsive" v-show="!cargandoSalidaDeHoy"
                        :idDelInput="ID_TABLA_SALIDAS_DIA_ACTUAL"
                        :encabezadosColumnas="encabezadosColumnasSDA"
                        :accionesEnTabla="ACCIONES_TABLA_CONSTITUCIONES"
                        :listaDeCedulas="salidaDeHoyTabla"
                        v-on:accionFuncionDetalles="evtDetallesDeCedula"
                        :conResponsive="true"
                        v-on:elementosSeleccionados="evtObtenerCedulasSeleccionadas"
                        :ref="REF_TABLA_SALIDAS_DIA_ACTUAL"></CTablaGenericaCedulas>
                        <div v-if="cargandoSalidaDeHoy" class="contenedor-cargando" style="height: 300px ;">
                            <div class="text-center">
                                <i class="fas fa-spinner fa-spin fa-5x"></i>
                                <h4 class="mt-4">Cargando Cédulas</h4>
                            </div>
                        </div>
                        <div v-if="constituciones.cedulas.some(c => c.enviar) && !cargandoSalidaDeHoy" class="d-flex justify-content-between mt-4">
                            <h6>[#Cédulas seleccionadas para constituir: {{ constituciones.cedulas.filter(c => c.enviar).length + ']'}}</h6>
                            <button @click="evtGuardarConstitucion" type="button" class="btn btn-primary justify-content-end"><i class="fas fa-clipboard-check"></i>&nbsp;&nbsp;Constituir</button>
                        </div>
                    </div>
                    <div style="padding: 5em 0 0 0">
                        <div class="d-flex">
                            <h3>Historial de salidas</h3>
                        </div>
                    </div>
                    <div id="contenedor-historial-salidas" class="">
                       <!--  <h5>Mi historial de salidas</h5> -->
                        <div class="form-inline mt-2 mb-4">
                            <h6 for="fecha-busqueda-hs-sn" class="mr-2">Fecha de búsqueda</h6>
                            <input id="fecha-busqueda-hs-sn" type="date" v-model="fechaBusqueda" class="form-control mr-3" />
                            <button type="button" @click="evtBuscarSalidaFechaEspecifica" class="btn btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                        </div>
                        <!-- <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/> -->
                        <CTablaGenericaCedulas class="mt-3 table-responsive" v-show="!cargandoSalidaFechaEspecifica" 
                            :idDelInput="ID_TABLA_HISTORIAL_SALIDAS"
                            :encabezadosColumnas="encabezadosColumnasHS"
                            :accionesEnTabla="ACCIONES"
                            :conResponsive="true"
                            :listaDeCedulas="salidaFechaIndicadaTabla"></CTablaGenericaCedulas>
                            <!-- <div v-if="salidaFechaIndicadaTabla.length < 1 && !cargandoSalidaFechaEspecifica" class="contenedor-sin-cedula" >
                                <div class="text-center">
                                    <i class="fas fa-file-alt" style="font-size: 9em;"></i>
                                    <h6 style="margin-top:2em;">{{mensajeSinResultados}}</h6>
                                </div>
                            </div> -->
                            <div v-show="cargandoSalidaFechaEspecifica" class="contenedor-cargando" style="height: 300px ;">
                                <div class="text-center">
                                    <i class="fas fa-spinner fa-spin fa-5x"></i>
                                    <h4 class="mt-4">Cargando Cédulas</h4>
                                </div>
                            </div>
                    </div>
               </div>
            </div>
        </div>
        <!-- <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="formulario-anexo-constitucion">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Formulario de constitución</h5>
                        <button id="btn-cerrar-formulario-anexo-constitucion" @click="evtCerrarFormularioConstitucion" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body">
                        <div id="contenedor-error-formulario" v-if="mostrarErroresFormAnexos && !this.archivoDeAnexoEsValido()">
                            <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en Formulario</h6>
                            <span style="text-align: justify; display:block;">Para poder agregar un anexo debes seleccionar un archivo(.JPEG, .JPG, .PNG, .PDF)</span>
                        </div>
                        <div class="contenedor-color-negro form-group">
                            <h6 for="obs_constitucion">Observaciones (opcional)</h6>
                            <textarea id="obs_constitucion" v-model="observacionesConstitucion" rows="4" type="text" class="form-control"/>
                            <hr/>
                            <h6 for="seccion-archivo-anexo">Anexo (opcional)&nbsp;
                                <i v-if="mostrarErroresFormAnexos && this.archivoDeAnexoEsValido()" class="fas fa-check-circle text-success font-size: 15px;"></i>
                                <i v-if="mostrarErroresFormAnexos && !this.archivoDeAnexoEsValido()" class="fas fa-times-circle text-danger font-size: 25px;"></i></h6>
                            <div class="form-inline justify-content-between" id="seccion-archivo-anexo">
                                <input type="file" id="input-anexo-archivo-salidas-notificador" :class="[mostrarErroresFormAnexos && !this.archivoDeAnexoEsValido() ? 'form-control border border-danger col-7' : 'form-control col-7']" v-on:change="evtAgregarAnexo($event)" accept=".JPEG,.JPG,.PNG,.PDF" />
                                <button v-if="!cancelarAgregarAnexo" type="button" @click="evtAgregarAnexoEnLista" class="btn-sm btn-primary"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar</button>
                                <button v-if="cancelarAgregarAnexo" type="button" @click="cancelarAgregarAnexo = false, mostrarErroresFormAnexos = false" class="btn-sm btn-primary"><i class="fas fa-times-circle"></i>&nbsp;&nbsp;Cancelar</button>
                            </div>
                            <div v-show="anexosTabla.length > 0" id="tabla-anexos" class="mt-3">
                                <CTablaGenericaCedulas class="table-responsive"
                                    :ref="REF_TABLA_ANEXOS"
                                    :idDelInput="ID_TABLA_ANEXOS"
                                    :encabezadosColumnas="encabezadosColumnasTA"
                                    :accionesEnTabla="ACCIONES_TANEXOS"
                                    :listaDeCedulas="anexosTabla"
                                    v-on:accionFuncionEliminar="evtRemoverAnexo($event)"></CTablaGenericaCedulas>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end mt-1"><button type="button" @click="evtGuardarConstitucion" class="btn-sm btn-primary"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button></div>
                    </div>             
                </div>
            </div>
        </div> -->
         <div class="modal align-middle visor-documento" tabindex="-1" data-backdrop="static" data-keyboard="false" id="descripcion-cedula-VSDDNM">
          <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title"><i class="fas fa-info-circle"></i>&nbsp;Observaciones de abogado</h5>
                      <button id="'btn-cerrar-descripcion-cedula-VSDDNM" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                  </div>
                  <div class="modal-body">
                      <div class="p-2">
                        <div class="form-group info" id="ObservacionesAbogado_div">
                            <h6>Observaciones para cédula [ Folio: #{{ folioCedulaSeleccionada }} ]</h6>
                            <!-- <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/> -->
                            <div v-if="observacionesDeAbogado.length < 1" class="contenedor-observaciones" style="margin: 2em 0 0 0">
                                <h6 class="text-center">Sin observaciones</h6>
                            </div>
                            <div id="contenedor-observacion">
                                <div v-for="(observacion,index) in observacionesDeAbogado" class="form-group" :key="index">
                                    <div class="form-inline">
                                        <h6>[{{obtenerNombreCompleto(observacion)}}]</h6>
                                        <button :id="observacion.ObservacionAbogadoId" type="button" @click="evtEliminarObservacionAbogado($event)" class="ml-2 btn-sm btn-primary"><i :id="observacion.ObservacionAbogadoId" class="fas fa-trash-alt"></i></button>
                                    </div>
                                    <textarea disabled v-model="observacion.Observaciones" type="text" rows="3" class="form-control mt-2"/>
                                </div>
                            </div>
                        </div>
                      </div>
                  </div>  
              </div>
          </div>
      </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import router from '@/router/index'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
    components: {
         CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas
    },
    data() {
        return {
            enumeraciones,
            ID_TABLA_SALIDAS_DIA_ACTUAL: 'TsalidasDelDiaActualSN',
            REF_TABLA_SALIDAS_DIA_ACTUAL: 'RefTsalidasDelDiaActualSN',
            ID_TABLA_ANEXOS: 'TanexosConstitucionSN',
            ID_TABLA_HISTORIAL_SALIDAS: 'ThistorialDeSalidasSN',
            REF_TABLA_ANEXOS: 'TanexosConstitucionSN',
            encabezadosColumnasTA: ['#','Anexo',''],
            encabezadosColumnasSDA: ['Folio','Consecutivo','Urgente','Domicilio','Persona a notificar','Tipo de cédula','Fecha de asignación',''],
            encabezadosColumnasHS: ['Folio','Consecutivo','Urgente','Domicilio','Persona a notificar','Tipo de cédula','Fecha de asignación', 'Constituida'],
            ACCIONES_TABLA_CONSTITUCIONES: {motrarAcciones: true,check: true, eliminar: false, constituir: false, detalles: true },
            ACCIONES: {motrarAcciones: false,check: false, eliminar: false},
            ACCIONES_TANEXOS: {motrarAcciones: true,check: false, eliminar: true},
            diaActual: moment(),
            diaSiguiente: moment().add(1,'days'),
            notificadorId: -1,
            duracion: null,
            fechaBusqueda: null,
            observacionesConstitucion: null,
            salidasListaP: [
                {Folio: 1, Urgente: 'SI', juzgado: 'Direccion de notificadores civiles', TipoDoc: 'Exp. principal',Consecutivo: '001/02' , TipoC: 'Notificacion', Fasig: '2020-09-29',boton: `<button id="prueba-btn-1" type="button" class="btn btn-primary w-70"><i class="fas fa-clipboard-check"></i>&nbsp;&nbsp;Constituir</button>`},
                {Folio: 1, Urgente: 'SI', juzgado: 'Direccion de notificadores civiles', TipoDoc: 'Exp. principal',Consecutivo: '001/02' , TipoC: 'Notificacion', Fasig: '2020-09-29',boton: `<button id="prueba-btn-2" type="button" class="btn btn-primary w-70"><i class="fas fa-clipboard-check"></i>&nbsp;&nbsp;Constituir</button>`},
                {Folio: 1, Urgente: 'SI', juzgado: 'Direccion de notificadores civiles', TipoDoc: 'Exp. principal',Consecutivo: '001/02' , TipoC: 'Notificacion', Fasig: '2020-09-29',boton: `<button id="prueba-btn-3" type="button" class="btn btn-primary w-70"><i class="fas fa-clipboard-check"></i>&nbsp;&nbsp;Constituir</button>`}
            ],
            salidasListaPH: [
                {Folio: 1, Urgente: 'SI', juzgado: 'Direccion de notificadores civiles', TipoDoc: 'Exp. principal',Consecutivo: '001/02' , TipoC: 'Notificacion', Fasig: '2020-09-29',boton: 'SI'},
                {Folio: 1, Urgente: 'SI', juzgado: 'Direccion de notificadores civiles', TipoDoc: 'Exp. principal',Consecutivo: '001/02' , TipoC: 'Notificacion', Fasig: '2020-09-29',boton: 'SI'},
                {Folio: 1, Urgente: 'SI', juzgado: 'Direccion de notificadores civiles', TipoDoc: 'Exp. principal',Consecutivo: '001/02' , TipoC: 'Notificacion', Fasig: '2020-09-29',boton: 'SI'}
            ],
            anexosDeConstitucion: [],
            anexosTabla: [],
            archivoAnexoSeleccionado: null,
            contadorAnexos: 0,
            mostrarErroresFormAnexos: false,
            cancelarAgregarAnexo: false,
            cedulaSeleccionada: null,
            salidaDeHoyBD: [],
            salidaDeHoyTabla: [],
            salidaFechaIndicadaBD: [],
            salidaFechaIndicadaTabla: [],
            cargandoSalidaDeHoy: false,
            cargandoSalidaFechaEspecifica: false,
            mensajeSinResultados: 'No se ha realizado ninguna búsqueda',
            filtrosPreviosVistaResultado: null,
            FORMATO_FECHA: "DD/MM/YYYY HH:mm:ss",
            observacionesDeAbogado: [],
            folioCedulaSeleccionada: null,
            observacionesDeAbogado: [],
            constituciones: {
                cedulas: [],
                fechaBusqueda: moment().format('YYYY-MM-DD')
            }
        }
    },
    methods: {
        obtenerPersistenciaDeSeleccion: function() {
            if(this.salidaDeHoyTabla.length > 0) {
                let cedulasSeleccionadasConFiltros = [];
                this.salidaDeHoyTabla
                .forEach(c => {
                    const CEDULA_SELECCIONADA = this.constituciones.cedulas.find(cs => cs.folio == c.Folio);
                    //console.log('CEDULA_SELECCIONADA::',CEDULA_SELECCIONADA);
                    if(this.campoRequeridoEsValido(CEDULA_SELECCIONADA))
                       cedulasSeleccionadasConFiltros.push(CEDULA_SELECCIONADA); 
                });
                //console.log('cedulasSeleccionadasConFiltros::',cedulasSeleccionadasConFiltros);
                this.constituciones.cedulas = cedulasSeleccionadasConFiltros;
            }

            // limpia los check seleccionados previamente
            if(this.salidaDeHoyTabla.length == 0) {
                this.constituciones.cedulas = [];
            }
            
            this.$nextTick(() => {
                this.constituciones.cedulas.filter(c => c.enviar).forEach(cedulaSeleccionada => {
                    this.$refs[this.REF_TABLA_SALIDAS_DIA_ACTUAL].seleccionDeCedulaComponentePadre(cedulaSeleccionada.idCheck);
                });
            });
        },
        evtObtenerCedulasSeleccionadas: function(evento) { 
            this.constituciones.cedulas = evento.filter(c => c.enviar);
        },
        evtConstituirCedulas: function() {

        },
        eliminarObservacionBD: function(peticionAPI) {
            const SERVIDOR = api.conexion;
            const METODO_API_ELIMINAR = api.SINOJ.sistema.notificaciones.salidasDelDia.EliminarObservacionesDeAbogado;
            let urlApi = SERVIDOR + METODO_API_ELIMINAR;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            const CEDULA_ACTUALIZADA = respuesta.data.Cedula;
                            if(this.campoRequeridoEsValido(CEDULA_ACTUALIZADA)) {
                                const INDEX_CEDULA_SIN_ACTUALIZAR = this.salidaDeHoyBD.findIndex(s => s.Cedula.CedulaId == peticionAPI.Cedula.CedulaId);
                                if(this.campoRequeridoEsValido(INDEX_CEDULA_SIN_ACTUALIZAR)) {
                                    this.salidaDeHoyBD[INDEX_CEDULA_SIN_ACTUALIZAR].Cedula.ObservacionesDeAbogados = CEDULA_ACTUALIZADA.ObservacionesDeAbogados;
                                    this.observacionesDeAbogado = this.salidaDeHoyBD[INDEX_CEDULA_SIN_ACTUALIZAR].Cedula.ObservacionesDeAbogados;
                                }
                            }
                        }
                        $('#descripcion-cedula-VSDDNM').modal('show');
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        informarConfirmacionDeEliminarObservacion: function (idObservacion) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `Estas seguro que deseas eliminar la observación<br>¿Desea continuar?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        let peticionEliminarObservacion = {
                            Cedula: {
                                CedulaId: this.folioCedulaSeleccionada,
                                ObservacionesDeAbogados: [
                                    { ObservacionAbogadoId: idObservacion }
                                ]
                            },
                            esPrueba: false
                        }
                        this.eliminarObservacionBD(peticionEliminarObservacion);
                    }
                    else {
                        $('#descripcion-cedula-VSDDNM').modal('show');
                    }
                }
            });
        },
        evtEliminarObservacionAbogado: function(evento) {
            $('#descripcion-cedula-VSDDNM').modal('hide');
            const OBSERVACION_SELECCIONADA = parseInt(evento.target.getAttribute('id'));
            this.informarConfirmacionDeEliminarObservacion(OBSERVACION_SELECCIONADA);
        },
        obtenerNombreCompleto: function(observacion) {
            const USUARIO_OBSERVACION = observacion.Usuario;
            if(USUARIO_OBSERVACION == null) {
                return 'Sin usuario';
            }
            const DATOS_NOMBRE = [USUARIO_OBSERVACION.Nombre, USUARIO_OBSERVACION.ApellidoPaterno, USUARIO_OBSERVACION.ApellidoMaterno];
            return DATOS_NOMBRE.join(' ');
        },
        evtDetallesDeCedula: function(evento) { debugger
            const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
            const ID_CEDULA = parseInt(this.obtenerCedula(CEDULA_SELECCIONADA));
            this.observacionesDeAbogado = [];
            const DATOS_SALIDA = this.salidaDeHoyBD.find(s => s.Cedula.CedulaId == ID_CEDULA);
            if(this.campoRequeridoEsValido(DATOS_SALIDA.Cedula)) {
                const { ObservacionesDeAbogados, CedulaId } = DATOS_SALIDA.Cedula;
                this.folioCedulaSeleccionada = CedulaId;
                if(ObservacionesDeAbogados != null) 
                    this.observacionesDeAbogado = ObservacionesDeAbogados;
            }
            $('#descripcion-cedula-VSDDNM').modal('show');
        },
        obtenerCedula: function(cedulaSeleccionada) {
            const CEDULA = cedulaSeleccionada.split('-');
            const POSICION_ID = (CEDULA.length - 1);
            const ID_CEDULA = CEDULA[POSICION_ID];
            return ID_CEDULA;
        },
        evtRemoverAnexo: function(evento) {
            const ANEXO_SELECCIONADO = evento.target.getAttribute('id');
            const ID_ANEXO_COMPLETO = ANEXO_SELECCIONADO.split('-');
            const ID_ANEXO = ID_ANEXO_COMPLETO[ID_ANEXO_COMPLETO.length -1];
            this.anexosTabla = this.anexosTabla.filter(a => a.Folio != ID_ANEXO);
            /* this.$nextTick(() => {
                $("*[id^=constituir-btn]").on("click", (evento) => {
                    this.evtConstituirCedula(evento);
                });
            }); */
            this.anexosDeConstitucion = this.anexosDeConstitucion.filter(ad => ad.Referencia != ID_ANEXO);
            if(this.anexosTabla.length < 1 && this.anexosDeConstitucion.length < 1)
                this.contadorAnexos = 0; 
        },
        evtBuscarSalidaFechaEspecificaParaConstitucion: function() {
            if(this.constituciones.fechaBusqueda != null  && this.constituciones.fechaBusqueda <= moment().format('YYYY-MM-DD')) {
                if(this.constituciones.cedulas.filter(cs => cs.enviar).length > 0) {
                    this.informarConfirmacionPedidaCedulasSeleccionadas();
                }
                else {
                    this.constituciones.cedulas = [];
                    this.mensajeSinResultados = `No se encontraron cedulas en la salida del dia ${this.constituciones.fechaBusqueda}`;
                    let peticionAPI = { NotificadorId: this.notificadorId, EsHistorial: false, FechaInicial: this.constituciones.fechaBusqueda, esPrueba: false };
                    this.obtenerSalidasDeNotificadorBD(peticionAPI,true);
                }
            }
            else {
                comun.mensajeDeAlerta('Se detectaron campos incorrectos,<br>Debes ingresar una fecha valida que sea menor o igual a la fecha de hoy: ' + moment().format('DD-MM-YYYY'));
            }
        },
        informarConfirmacionPedidaCedulasSeleccionadas: function (solicitudCedulasReporte) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `Se encuentran cedulas seleccionadas para constituir,<br>Si deseas continuar se perdera el marcado de seleccion de las cedulas`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbspCancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;Confirmar'
                    },
                },
                callback: async (respuesta) => {
                    if (respuesta) {
                        this.constituciones.cedulas = [];
                        this.mensajeSinResultados = `No se encontraron cedulas en la salida del dia ${this.constituciones.fechaBusqueda}`;
                        let peticionAPI = { NotificadorId: this.notificadorId, EsHistorial: false, FechaInicial: this.constituciones.fechaBusqueda, esPrueba: false };
                        this.obtenerSalidasDeNotificadorBD(peticionAPI,true);
                    }
                }
            });
        },
        evtBuscarSalidaFechaEspecifica: function() {
            if(this.fechaBusqueda != null) {
                this.mensajeSinResultados = `No se encontraron cedulas en la salida del dia ${this.fechaBusqueda}`;
                let peticionAPI = { NotificadorId: this.notificadorId, EsHistorial: true, FechaInicial: this.fechaBusqueda, esPrueba: false };
                this.obtenerSalidasDeNotificadorBD(peticionAPI,false);
            }
            else {
                comun.mensajeDeAlerta('No hay una fecha seleccionada');
            }
        },
        evtRegresarVistaPrincipal: function() {
            let tieneFiltroPrevios = Object.values(this.filtrosPreviosVistaResultado).some(f => {
                if(typeof f === 'string' || f instanceof String) {
                    // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                    if (f != null && f != undefined && f != '') {
                        return true;
                    }
                }
                else if (typeof f === 'number' || f instanceof Number) {
                    // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                    if (f != null && f != undefined && f > 0) {
                        return true;
                    }
                }
            });
            this.filtrosPreviosVistaResultado.cargarConFiltros = tieneFiltroPrevios;
            router.push({ name: "SalidasDelDia", params: { filtrosParaCargar: this.filtrosPreviosVistaResultado, filtrosPreviosVistaHija: this.constituciones.fechaBusqueda } });
        },
        evtCerrarFormularioConstitucion: function() {
            this.limpiarFormularioConstitucion();
        },
        evtGuardarConstitucion: async function() {
            let peticionAPI = await Promise.resolve(this.crearPeticionDeConstitucion());
            console.log('peticion::',peticionAPI);
            this.guardarConstitucionDeCedulaBD(peticionAPI);
        },
        guardarConstitucionDeCedulaBD: function(peticionAPI) {
           const SERVIDOR = api.conexion;
           const METODO_API_GUARDAR = api.SINOJ.sistema.notificaciones.salidasDelDia.GuardarNuevaConstitucion;
           let urlApi = SERVIDOR + METODO_API_GUARDAR;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
             $('#formulario-anexo-constitucion').modal('hide');
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                             $('#formulario-anexo-constitucion').modal('show');
                        } 
                        else {
                            //console.log("guardarConstitucionDeCedulaBD::ejecuto bien:: ",respuesta.data);
                            /* this.removerCedulaConstituidaSalida();
                            this.limpiarFormularioConstitucion(); */
                            //$('#btn-cerrar-formulario-anexo-constitucion').trigger('click');
                            this.constituciones.cedulas = [];
                            let peticionSH = { NotificadorId: this.notificadorId,EsHistorial: false, FechaInicial: this.constituciones.fechaBusqueda, esPrueba: false };
                            this.obtenerSalidasDeNotificadorBD(peticionSH,true);
                            if(this.constituciones.fechaBusqueda == this.fechaBusqueda) {
                                let peticionHS = { NotificadorId: this.notificadorId,EsHistorial: true, FechaInicial: this.fechaBusqueda, esPrueba: false };
                                this.obtenerSalidasDeNotificadorBD(peticionHS,false);
                            }
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        }
                        /* comun.SeEstaCargandoInformacion(false); */
                    })
                    .catch(excepcion => {
                        this.cargandoSalidaDeHoy = false;
                        this.cargandoSalidaFechaEspecifica = false;
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        removerCedulaConstituidaSalida: function() {
            this.salidaDeHoyBD = this.salidaDeHoyBD.filter(s => s.SalidaId != this.cedulaSeleccionada.SalidaId);
            this.salidaDeHoyTabla = this.darFormatoCedulasTabla(this.salidaDeHoyBD,true);
        },
        crearPeticionDeConstitucion: async function() {
            //let peticion = new FormData();
            let peticion = {};
            let cedulasDeSalida = [];
            this.constituciones.cedulas.filter(cc => {
                let salidaObjCompleto = this.salidaDeHoyBD.find(sh => sh.Cedula.CedulaId == cc.folio);
                if(this.campoRequeridoEsValido(salidaObjCompleto)) {
                    let salidaObj = {};
                    salidaObj.SalidaId = salidaObjCompleto.SalidaId;
                    salidaObj.FechaSalida = moment();
                    salidaObj.Notificador = null;
                    salidaObj.Cedula = {
                        CedulaId: salidaObjCompleto.Cedula.CedulaId
                    };
                    let constitucionObj = {};
                    constitucionObj.ConstitucionId = -1;
                    constitucionObj.FechaConstitucion = moment();
                    constitucionObj.Observaciones = null;
                    constitucionObj.Salida = null;
                    let anexosObj = [];
                    /* this.anexosDeConstitucion.forEach(a => {
                        peticion.append(a.Referencia,a.Archivo);
                        let anexoObj = {};
                        anexoObj.AnexosConstitucionId = -1;
                        anexoObj.AnexoRuta = a.Referencia;
                        anexoObj.Constitucion = null;
                        anexosObj.push(anexoObj);
                    }); */
                    constitucionObj.Anexos = anexosObj;
                    salidaObj.Constituciones = [constitucionObj];
                    cedulasDeSalida.push(salidaObj);
                }
            })
           /*  peticion.append('Salida',JSON.stringify(salidaObj));
            peticion.append('EsPrueba',false); */
            /* console.log('VALORES FORMDATA');
            for (var pair of peticion.entries()) {
                console.log(pair[0]+ ', ',pair[1]); 
            } */
            peticion.esPrueba = false;
            peticion.Salidas = cedulasDeSalida;
            return peticion;
        },
        evtAgregarAnexoEnLista: function() {
            if(this.archivoDeAnexoEsValido()) {
                let anexoObjTabla = {};
                anexoObjTabla.Folio = this.contadorAnexos += 1;
                anexoObjTabla.Anexo = this.archivoAnexoSeleccionado.name;
                this.anexosTabla.push(anexoObjTabla);
                let archivoAnexo = {};
                archivoAnexo.Referencia = anexoObjTabla.Folio;
                archivoAnexo.Archivo = this.archivoAnexoSeleccionado;
                this.anexosDeConstitucion.push(archivoAnexo);
                if(this.anexosTabla.length > 0 && this.anexosDeConstitucion.length > 0) {
                    $("#input-anexo-archivo-salidas-notificador").val('');
                    this.archivoAnexoSeleccionado = null;
                     this.mostrarErroresFormAnexos = false;
                }
            }
            else {
                this.cancelarAgregarAnexo = true;
                this.mostrarErroresFormAnexos = true;
            }
        },
        limpiarFormularioConstitucion: function() {
            this.observacionesConstitucion = null;
            this.archivoAnexoSeleccionado = null;
            this.mostrarErroresFormAnexos = false;
            this.anexosTabla = [];
            this.anexosDeConstitucion = [];
            $("#input-anexo-archivo-salidas-notificador").val('');
            this.contadorAnexos = 0;
            this.cancelarAgregarAnexo = false;
            this.cedulaSeleccionada = null;
        },
        archivoDeAnexoEsValido: function() {
            let esValido = false;
            if(this.archivoAnexoSeleccionado != null)
                esValido = true;
            return esValido
        },
        evtAgregarAnexo: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    this.archivoAnexoSeleccionado = evento.target.files[0];
                    this.cancelarAgregarAnexo = false;
                }
                else {
                    this.archivoAnexoSeleccionado = null;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
       /*  establecerContadorTiempoDiaActual: function() {
            var eventTime= this.diaSiguiente.format('YYYY-MM-DD'); // Timestamp - Sun, 21 Apr 2013 13:00:00 GMT
            var currentTime = this.diaActual.format('YYYY-MM-DD'); // Timestamp - Sun, 21 Apr 2013 12:30:00 GMT
            var diffTime = eventTime - currentTime;
            var duration = moment.duration(diffTime*1000, 'milliseconds');
            var interval = 1000;

            setInterval(function(){
            duration = moment.duration(duration - interval, 'milliseconds');
               
            }, interval);
        }, */
        evtConstituirCedula: function(evento) {
            this.cedulaSeleccionada = this.obtenerCedulaSeleccionado(evento);
            //console.log('cedSel::',this.cedulaSeleccionada);
            $('#formulario-anexo-constitucion').modal('show');
        },
        obtenerCedulaSeleccionado: function(evento) {
            let salida = null;
            const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
            const ID_CEDULA = parseInt(this.obtenerCedula(CEDULA_SELECCIONADA));
            this.salidaDeHoyBD.filter(sDB => sDB.Cedula.CedulaId == ID_CEDULA).forEach(s => {
                salida = s;
            });
            return salida;
        },
        obtenerCedula: function(cedulaSeleccionada) {
            const CEDULA = cedulaSeleccionada.split('-');
            const POSICION_ID = (CEDULA.length - 1);
            const ID_CEDULA = CEDULA[POSICION_ID];
            return ID_CEDULA;
        },
        obtenerSalidasDeNotificadorBD: function(peticionAPI,salidaDeHoy) {
           const SERVIDOR = api.conexion;
           const METODO_API_OBTENER = api.SINOJ.sistema.notificaciones.salidasDelDia.ObtenerSalidasDeNotificador;
           let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            this.cargandoSalidaDeHoy = (salidaDeHoy) ? true : false;
            this.cargandoSalidaFechaEspecifica = (!salidaDeHoy) ? true : false;
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            //console.log("obtenerSalidasDeNotificadorBD::ejecuto bien:: ",respuesta.data);
                            if(salidaDeHoy) {
                                this.salidaDeHoyBD = (respuesta.data.Salidas != null) ? respuesta.data.Salidas : [];
                                this.salidaDeHoyTabla = this.darFormatoCedulasTabla(this.salidaDeHoyBD,salidaDeHoy);
                                //console.log('tsh::',this.salidaDeHoyTabla);
                                /* this.$nextTick(() => {
                                    $("*[id^=constituir-btn]").on("click", (evento) => {
                                        this.evtConstituirCedula(evento);
                                    });
                                }); */
                                this.obtenerPersistenciaDeSeleccion();
                            }
                            else {
                                this.salidaFechaIndicadaBD = (respuesta.data.Salidas != null) ? respuesta.data.Salidas : [];
                                this.salidaFechaIndicadaTabla = this.darFormatoCedulasTabla(this.salidaFechaIndicadaBD,salidaDeHoy);
                            }
                        }
                        this.cargandoSalidaDeHoy = false;
                        this.cargandoSalidaFechaEspecifica = false;
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        this.cargandoSalidaDeHoy = false;
                        this.cargandoSalidaFechaEspecifica = false;
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
         /**
         * funcion encargado de dar formato a objetos de cedula al formato
         * [Folio,Urgente,Tipo de cedula,Fecha de asignación] que ocupa la
         * tabla de la vista. 
         * @param {object} cedulas [fuente de datos de cedulas]
         * @see {@link cedulaAObjetoTabla}
         */
        darFormatoCedulasTabla: function(cedulas,salidaDeHoy) {
            let cedulasConFormato = [];
            cedulasConFormato = cedulas.map(s => {
                let cedula = this.cedulaAObjetoTabla(s, salidaDeHoy);
                return cedula;
            });
            return cedulasConFormato;
        },
        cedulaAObjetoTabla: function(salida,salidaDeHoy) { debugger
            // 'Folio','Consecutivo','Urgente','Domicilio','Persona a notificar','Tipo de cédula','Fecha de asignación'
            let cedulaObjTabla = {};
            cedulaObjTabla.Folio = salida.Cedula.CedulaId;
            cedulaObjTabla.Consecutivo = 'Sin consecutivo';
            if(this.campoRequeridoEsValido(salida.Cedula.Expediente)) { 
                cedulaObjTabla.Consecutivo = salida.Cedula.Expediente.NumeroDeDocumento;
            }
            cedulaObjTabla.urgente = (salida.Cedula.Urgente) ? 'SI' : 'NO';
            cedulaObjTabla.Domicilio = 'Sin Domicilio';
            cedulaObjTabla.PersonaANotificar = 'Sin Persona a Notificar';
            if(this.campoRequeridoEsValido(salida.Cedula.PersonasANotificar)) {
                if(salida.Cedula.PersonasANotificar[0].Domicilios != null && salida.Cedula.PersonasANotificar[0].Domicilios.length > 0) {
                    const DOMICILIO_OBJ = salida.Cedula.PersonasANotificar[0].Domicilios[0];
                    let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                    let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
                    if(this.campoRequeridoEsValido(DOMICILIO_OBJ.Fraccionamiento)) {
                        cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`;
                    }
                    else {
                        /* 
                            para los casos de domicilios con fraccionamiento que no pertenece al catalogo de fraccionamientos, se guarda la informacion el un solo campo (008FraccionamientoFueraDeCatalogo => FraccionamientoFueraDeCatalogo)
                            con el siguiente formato NOMBRE_FRACCIONAMIENTO, NOMBRE_MUNICIPIO, si se modifica posteriormenete este formato se tendra que reemplazar esta 
                            logica.
                            */
                        let fraccionamientoCompuesto = DOMICILIO_OBJ.FraccionamientoFueraDeCatalogo.split(',');
                        let nombreFraccionamiento = fraccionamientoCompuesto[0];
                        let nombreMunicipio = fraccionamientoCompuesto[1];
                        cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
                    }

                    /* const DOMICILIO_OBJ = salida.Cedula.PersonaANotificar.Domicilios[0];
                    let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                    let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior }` : '';
                    cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`; */
                }
                
                if(this.campoRequeridoEsValido(salida.Cedula.PersonasANotificar[0].DatosGenerales)) {
                    const { Fisica, Moral } = salida.Cedula.PersonasANotificar[0].DatosGenerales;
                    if(this.campoRequeridoEsValido(Fisica))
                        cedulaObjTabla.PersonaANotificar = `${ Fisica.Nombre.toUpperCase().trim() } ${ Fisica.ApellidoPaterno.toUpperCase().trim() }${ (this.campoRequeridoEsValido(Fisica.ApellidoMaterno)) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
                    else if(this.campoRequeridoEsValido(Moral))
                        cedulaObjTabla.PersonaANotificar = `${ Moral.Nombre.trim() }`; 
                }
            }
            cedulaObjTabla.TipoCedula = (this.campoRequeridoEsValido(salida.Cedula.TipoCedula.Nombre)) ? salida.Cedula.TipoCedula.Nombre.trim() : 'Sin tipo de cedula';
            cedulaObjTabla.fechaAsignacion = this.campoRequeridoEsValido(salida.Cedula.AsignacionesDeNotificador[0].FechaDeAsignacion) ? moment(salida.Cedula.AsignacionesDeNotificador[0].FechaDeAsignacion).format(this.FORMATO_FECHA) : 'Sin fecha de asignacion';
            /* if(salidaDeHoy)
                cedulaObjTabla.btn = `<button id="constituir-btn-${salida.Cedula.CedulaId}" type="button" class="btn btn-primary w-70"><i class="fas fa-clipboard-check"></i>&nbsp;&nbsp;Constituir</button>`;
            else */
            if(!salidaDeHoy)
                cedulaObjTabla.constituida = (this.cedulaFueConstituida(salida)) ? 'SI' : 'NO';
            return cedulaObjTabla;
        },
        cedulaFueConstituida: function(salida) {
            let cedulaFueConstituida = salida.Constituciones != null && salida.Constituciones.length > 0;
            return cedulaFueConstituida;
        },
        campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'array' || campo instanceof Array) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo.length > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      ...mapActions([
        'A_SINOJ_establecerCedulasSeleccionadas_SalidasDeNotificador',
        'A_SINOJ_establecerCedulasSeleccionadas_SalidasDelDia'
      ])
    },
    created() {
        const PARAMETROS_VISTA = router.history.current.params;
        if(PARAMETROS_VISTA.filtrosPreviosVistaHija != null || PARAMETROS_VISTA.filtrosPreviosVistaHija != undefined) {
            console.log('PARAMETROS_VISTA::',PARAMETROS_VISTA.filtrosPreviosVistaHija);
            this.constituciones.fechaBusqueda = PARAMETROS_VISTA.filtrosPreviosVistaHija;
        }

        if(PARAMETROS_VISTA.filtrosPrevios == null || PARAMETROS_VISTA.filtrosPrevios == undefined) {
            router.push({ name: "SalidasDelDia"});
        }
        else {
            this.notificadorId = parseInt(router.history.current.params.idNotificador);
            this.filtrosPreviosVistaResultado = PARAMETROS_VISTA.filtrosPrevios;
            let peticionAPI = { NotificadorId: this.notificadorId,EsHistorial: false,  FechaInicial: this.constituciones.fechaBusqueda, esPrueba: false };
            this.obtenerSalidasDeNotificadorBD(peticionAPI,true);
        }

        if(this.obtenerCedulasSeleccionadasPrevias != null && this.obtenerCedulasSeleccionadasPrevias.length > 0) {
            this.constituciones.cedulas = this.obtenerCedulasSeleccionadasPrevias;
        }
    },
    computed: {
        obtenerDuracion() {
            return this.duracion;
        },
        obtenerCedulasSeleccionadasPrevias() {
            return this.$store.getters.Get_SINOJ_CedulasSeleccionadas_SalidasDeNotificador;
        },
    },
    watch: {
        anexosTabla() {
            if(this.anexosTabla.length > 0) {
                this.$refs[this.REF_TABLA_ANEXOS].cedulasAmostrarPorPagina = 1;
            }
        },
        'constituciones.cedulas': function() {
            this.A_SINOJ_establecerCedulasSeleccionadas_SalidasDeNotificador(this.constituciones.cedulas.filter(c => c.enviar));
            let todosLosElementosSeleccionados = (this.constituciones.cedulas.filter(c => c.enviar).length == this.salidaDeHoyTabla.length);
            this.$refs[this.REF_TABLA_SALIDAS_DIA_ACTUAL].mostrarSeleccionTodoComponentePadre(todosLosElementosSeleccionados);
        }
    },
    beforeRouteLeave (to, from, next) {
        const VISTA_PADRE = 'SalidasDelDia';
        if(to.name != VISTA_PADRE) {
          this.A_SINOJ_establecerCedulasSeleccionadas_SalidasDelDia([]);
          this.A_SINOJ_establecerCedulasSeleccionadas_SalidasDeNotificador([]);
        }
        next();
    }
}
</script>
<style scoped>
.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

#fecha-busqueda-informacion {
    background-color: #1e2020;
    height: 4em;
}

#formulario-anexo-constitucion .modal-lg {
    max-width: 50% !important;
}

#formulario-anexo-constitucion .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

.btn-sm {
    cursor: pointer;
}

textarea {
    padding: 0.6em !important;
}

#contenedor-error-formulario {
    padding: 1em;
    background-color: #26272b;
    border: 1px solid #5c5959;
    border-radius: 8px;
    margin-bottom: 1em;;
}

.btn-sm {
    color: white;
    background-color: rgb(36, 34, 34);
    border-color: white;
}

.btn-sm:hover, .btn-sm:focus {
    color: white;
    background-color: black;
    border-color: white;
}

.contenedor-sin-cedula {
    background-color: rgb(36, 34, 34);
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.contenedor-cargando {
    background-color: rgb(36, 34, 34);
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

#encabezado-contenedor-contenido {
  background-color: rgb(41, 40, 40);
  padding: 10px;
}

#encabezado-contenedor-contenido .btn {
  background-color: black;
  padding-left: 15px;
  padding-right: 15px;
}

.contenedor-observaciones {
    background-color: #242425;
    max-height: 16em;
    overflow-y: auto;
    padding: 8px;
    border-radius: 4px;
}

#contenedor-observacion {
    margin-top: 1em;
    padding-right: 10px;
    max-height: 16em;
    overflow-y: auto;
}

#contenedor-observacion .btn-sm {
    width: 25px;
    height: 25px;
    padding: 0;
    cursor: pointer;
}

#contenedor-observacion .btn-primary:active:hover,
#contenedor-observacion .btn-primary:hover,
#contenedor-observacion .btn-primary:focus {
    border-color: black;
    background-color: black;
}

#descripcion-cedula-VSDDNM .modal-lg {
    max-width: 50% !important;
}

#descripcion-cedula-VSDDNM .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Notificaciones/CedulasParaSalida/CSalidasDeNotificador.vue